module.exports = __webpack_public_path__ + "static/media/picture-(111).0176337e.JPG";